export const FICHAS = [
  {MATNR:"P11JX0021905642",MAKTX:"INDILEATHER ANIMALE NEW 9,4oz BLACK"},
  {MATNR:"P11JX0021714729",MAKTX:"INDILEATHER ANIMALE NEW 9,4oz ANTILOPE"},
  {MATNR:"P21JX0120307494",MAKTX:"INDICOLOR NIHON 4,5oz"},
  {MATNR:"P21JX0120600124",MAKTX:"INDICOLOR NIHON 4,5oz"},
  {MATNR:"P21JX0120107485",MAKTX:"INDICOLOR NIHON 4,5oz"},
  {MATNR:"P21JX0120723943",MAKTX:"INDICOLOR NIHON 4,5oz"},
  {MATNR:"P21JF0249725933",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P21JF0249726861",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P21JF0249726901",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P21JF0249726862",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P21JF0249609208",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P21JF0249300134",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P21JF0249326855",MAKTX:"INDICOLOR COTTON CETIM POWER EXTREME 7,8oz"},
  {MATNR:"P11JF0001",MAKTX:"Indicolor Coating Abstract 6,7 oz"},
  {MATNR:"P11JF0002",MAKTX:"Indicolor Coating Camuflado 6,7 oz"},
  {MATNR:"P11JF0003",MAKTX:"Indicolor Coating Daisy 6,7 oz"},
  {MATNR:"P11JF0005",MAKTX:"Indicolor Coating Liberty 6,7 oz"},
  {MATNR:"P11JF0025",MAKTX:"Indicolor Marble 6,7 oz"},
  {MATNR:"P11JF0028",MAKTX:"Indicolor Fiore Shiny Ii 6,7 oz"},
  {MATNR:"P11JF0030",MAKTX:"Indicolor Wire 6,7 oz"},
  {MATNR:"P11JF0037",MAKTX:"Indicolor Coating Cracked 6,7 oz"},
  {MATNR:"P11JF0038",MAKTX:"Indicolor Coating Fire Snake 6,7 oz"},
  {MATNR:"P11JF0039",MAKTX:"Indicolor Coating Ethnic 6,7 oz"},
  {MATNR:"P11JF0043",MAKTX:"Indicolor Coating Animal 6,7 oz"},
  {MATNR:"P11JF0044",MAKTX:"Indicolor Coating Galactic 6,7 oz"},
  {MATNR:"P11JF0045",MAKTX:"Indicolor Coating Candy 6,9 oz"},
  {MATNR:"P11JF0046",MAKTX:"Indicolor Coating Jungle 6,7 oz"},
  {MATNR:"P11JF0047",MAKTX:"Indicolor Feline 6,7 oz"},
  {MATNR:"P11JF0049",MAKTX:"Indicolor Coating Shiny Bouquet 6,7 oz"},
  {MATNR:"P11JF0050",MAKTX:"Indicolor Coating Shiny Cashmere 6,7 oz"},
  {MATNR:"P11JF0053",MAKTX:"Indicolor Coating Psychedelic 6,7 oz"},
  {MATNR:"P11JF0054",MAKTX:"Indicolor Coating Viper 6,7 oz"},
  {MATNR:"P11JF0055",MAKTX:"Indicolor Coating Scribble 6,7 oz"},
  {MATNR:"P11JF0056",MAKTX:"Indicolor Coating Shiny V 6,7 oz"},
  {MATNR:"P11JF0058",MAKTX:"Indc Coating Giardino 6,7oz"},
  {MATNR:"P11JF0060",MAKTX:"Indicolor Coating Safari 6,7 oz"},
  {MATNR:"P11JF0061",MAKTX:"Indicolor Coating Safari Color "},
  {MATNR:"P11JF0062",MAKTX:"Indicolor Coating Andrina 6,7 oz"},
  {MATNR:"P11JF0064",MAKTX:"Indicolor Coating Aurora 6,7 oz"},
  {MATNR:"P11JF0065",MAKTX:"Indicolor Coating Bella 6,7 oz"},
  {MATNR:"P11JF0066",MAKTX:"Indicolor Coating Cougar 6,7 oz"},
  {MATNR:"P11JF0067",MAKTX:"Indicolor Coating Intense 6,7 oz"},
  {MATNR:"P11JF0070",MAKTX:"Indicolor Jacquard Ornament 7,8 oz"},
  {MATNR:"P11JF0071",MAKTX:"Indicolor Jacquard Parquet 7,8 oz"},
  {MATNR:"P11JF0072",MAKTX:"Indicolor Jacquard Flourish 7,8 oz"},
  {MATNR:"P11JF0074",MAKTX:"Indicolor Coating Roots 6,7 oz"},
  {MATNR:"P11JF0075",MAKTX:"Indc Coating Phyton 6,7 oz"},
  {MATNR:"P11JF0076",MAKTX:"Indicolor Coating Smoky 6,7 oz"},
  {MATNR:"P11JF0077",MAKTX:"Indicolor Jacquard Botanic 7,8 oz"},
  {MATNR:"P11JF0078",MAKTX:"Indicolor Jacquard Exotic 7,8 oz"},
  {MATNR:"P11JF0079",MAKTX:"Indicolor Coating Dark Flowers I 6,7 oz"},
  {MATNR:"P11JF0080",MAKTX:"Indicolor Coating Dark Flowers Ii 6,7 oz"},
  {MATNR:"P11JF0081",MAKTX:"Indicolor Coating Shadow 6,7 oz"},
  {MATNR:"P11JF0082",MAKTX:"Indc Coating Gras Snake 6,7 oz"},
  {MATNR:"P11JF0083",MAKTX:"Indicolor Coating Serpent 6,7 oz"},
  {MATNR:"P11JF0084",MAKTX:"Índigo Montese Rustic New 8,5 oz"},
  {MATNR:"P11JF0085",MAKTX:"Indicolor Lizard 8,6 oz"},
  {MATNR:"P11JF0086",MAKTX:"Indicolor Lizard Optical 8,6 oz"},
  {MATNR:"P11JF0087",MAKTX:"Indicolor Coating Tree Snake 6,7 oz"},
  {MATNR:"P11JF0088",MAKTX:"Indicolor Coating Skin Snake 6,7 oz"},
  {MATNR:"P11JF0089",MAKTX:"Indicolor Coating Thunder 6,7 oz"},
  {MATNR:"P11JF0090",MAKTX:"Indicolor Coating Speed 6,7 oz"},
  {MATNR:"P11JF0091",MAKTX:"Indicolor Coating Blur 6,7 oz"},
  {MATNR:"P11JF0095",MAKTX:"Indicolor Coating Skull 6,7 oz"},
  {MATNR:"P11JF0096",MAKTX:"Indicolor Coating Exuberance 6,7 oz"},
  {MATNR:"P11JF0097",MAKTX:"Indicolor Coating Retille 6,7 oz"},
  {MATNR:"P11JF0098",MAKTX:"Indicolor Coating Shiny Leopard 6,7 oz"},
  {MATNR:"P11JF0099",MAKTX:"Indicolor Coating Inocense 6,7 oz"},
  {MATNR:"P11JF0100",MAKTX:"Indicolor Coating Feline Ii 6,7 oz"},
  {MATNR:"P11JF0101",MAKTX:"Indicolor Velvet Leopard Color 6,7 oz"},
  {MATNR:"P11JF0102",MAKTX:"Indicolor Coating Stone 6,7 oz"},
  {MATNR:"P11JF0103",MAKTX:"Indicolor Coating Glamour 6,7 oz"},
  {MATNR:"P11JF0104",MAKTX:"Indicolor Coating Snake Illusion 6,7 oz"},
  {MATNR:"P11JF0105",MAKTX:"Indicolor Coating Delicate 6,7 oz"},
  {MATNR:"P11JF0106",MAKTX:"Indicolor Cetim Power Vision 7,1 oz"},
  {MATNR:"P11JF0108",MAKTX:"Indicolor Cetim Power Visage 7,1 oz"},
  {MATNR:"P11JF0110",MAKTX:"Indicolor Coating Gerber 6,7 oz"},
  {MATNR:"P11JF0112",MAKTX:"Indicolor Coating Wild 6,7 oz"},
  {MATNR:"P11JF0113",MAKTX:"Indicolor Coating Desert Snake 6,7 oz"},
  {MATNR:"P11JF0114",MAKTX:"Indicolor Coating Amabile 6,7 oz"},
  {MATNR:"P11JF0115",MAKTX:"Indicolor Coating Reflex 6,7 oz"},
  {MATNR:"P11JF0116",MAKTX:"Indicolor Coating Mirror 6,7 oz"},
  {MATNR:"P11JF0117",MAKTX:"Indicolor Coating Rosebud 6,7 oz"},
  {MATNR:"P11JF0118",MAKTX:"Indicolor Coating Rainbow 6,7 oz"},
  {MATNR:"P11JF0119",MAKTX:"Indicolor Coating Eternity 6,7 oz"},
  {MATNR:"P11JF0120",MAKTX:"Indicolor Coating Petit 6,7 oz"},
  {MATNR:"P11JF0121",MAKTX:"Indicolor Coating Dream 6,7 oz"},
  {MATNR:"P11JF0122",MAKTX:"Indicolor Coating Contrast 6,7 oz"},
  {MATNR:"P11JF0123",MAKTX:"Indicolor Coating Burlesque 6,7 oz"},
  {MATNR:"P11JF0124",MAKTX:"Indicolor Coating Tropical 6,7 oz"},
  {MATNR:"P11JF0125",MAKTX:"Indicolor Coating Ocean 6,7 oz"},
  {MATNR:"P11JF0126",MAKTX:"Indicolor Coating Sweet 6,7 oz"},
  {MATNR:"P11JF0127",MAKTX:"Indicolor Coating Peony 6,7 oz"},
  {MATNR:"P11JF0128",MAKTX:"Indicolor Coating Magnific 6,7 oz"},
  {MATNR:"P11JF0129",MAKTX:"Indicolor Coating Dusk Snake 6,7 oz"},
  {MATNR:"P11JF0130",MAKTX:"Indicolor Velvet Iris 7,5 oz"},
  {MATNR:"P11JF0131",MAKTX:"Indicolor Velvet Leopard 7,5 oz"},
  {MATNR:"P11JF0132",MAKTX:"Indicolor Velvet Lily 7,0 oz"},
  {MATNR:"P11JF0133",MAKTX:"Indicolor Velvet Lotus 7,0 oz"},
  {MATNR:"P11JF0134",MAKTX:"Indicolor Velvet Pallizzi 7,5 oz"},
  {MATNR:"P11JF0136",MAKTX:"Indicolor  Velvet Amarilis 7,0 oz"},
  {MATNR:"P11JF0137",MAKTX:"Indicolor Jacquard Savage 8,4 oz"},
  {MATNR:"P11JF0138",MAKTX:"Indicolor Jacquard Elegant 8,4 oz"},
  {MATNR:"P11JF0139",MAKTX:"Indicolor Jacquard Classy 8,5 oz"},
  {MATNR:"P11JF0140",MAKTX:"Indicolor Jacquard Fancy 8,6 oz"},
  {MATNR:"P11JF0141",MAKTX:"Indicolor Jacquard Bent 8,0 oz"},
  {MATNR:"P11JF0143",MAKTX:"Indicolor Jacquard Divine 8,7 oz"},
  {MATNR:"P11JF0148",MAKTX:"Indicolor Jacquard Orbit 8,7 oz"},
  {MATNR:"P11JF0149",MAKTX:"Indicolor Jacquard Fine Camouflage 8,2 oz"},
  {MATNR:"P11JF0151",MAKTX:"Indicolor Jacquard Expression 8,4 oz"},
  {MATNR:"P11JF0152",MAKTX:"Indicolor Jacquard Flora 8,7 oz"},
  {MATNR:"P11JF0153",MAKTX:"Indicolor Jacquard Cetim Trim Birds 7,4 oz"},
  {MATNR:"P11JF0156",MAKTX:"Indicolor Ultra Power Expand 7,6 oz"},
  {MATNR:"P11JF0157",MAKTX:"Indileather Ultra Power Extend 8,0 oz"},
  {MATNR:"P11JF0160",MAKTX:"Indicolor Jacquard Cetim Trim Bike 7,4 oz"},
  {MATNR:"P11JF0161",MAKTX:"Indicolor Jacquard Cetim Diamond 9,9 oz"},
  {MATNR:"P11JX0003",MAKTX:"Indileather Twilled 10,3 oz"},
  {MATNR:"P11JX0004",MAKTX:"Indileather Square 10,5 oz"},
  {MATNR:"P11JX0007",MAKTX:"Indileather Extravagance 9,4 oz"},
  {MATNR:"P11JX0008",MAKTX:"Indileather Animale 9,4 oz"},
  {MATNR:"P11JX0009",MAKTX:"Indileather Caprini 5,9 oz"},
  {MATNR:"P11JX0012",MAKTX:"Indileather Spot 6,6 oz"},
  {MATNR:"P11JX0013",MAKTX:"Indileather Dimension 8,5 oz"},
  {MATNR:"P21JF0001",MAKTX:"Indicolor Duo 7,4 oz"},
  {MATNR:"P21JF0002",MAKTX:"Ind Clinker Resin 9,0 oz"},
  {MATNR:"P21JF0005",MAKTX:"Índigo New Azzurra Grey 9,0 oz "},
  {MATNR:"P21JF0006",MAKTX:"Índigo Enna Plus Black Blue 9,7 oz"},
  {MATNR:"P21JF0007",MAKTX:"Índigo Enna Plus Blue 9,7 oz"},
  {MATNR:"P21JF0008",MAKTX:"Índigo Enna Plus Black 9,7 oz"},
  {MATNR:"P21JF0010",MAKTX:"Índigo Coating Andora Blue 8,4 oz"},
  {MATNR:"P21JF0013",MAKTX:"Índigo Bersoni Focus Flex Blue 7,5 oz"},
  {MATNR:"P21JF0014",MAKTX:"Índigo Braone Focus Flex Blue 8,5 oz"},
  {MATNR:"P21JF0015",MAKTX:"Indigo Cameri oz"},
  {MATNR:"P21JF0018",MAKTX:"Índigo Coating Andora Black 8,4 oz"},
  {MATNR:"P21JF0019",MAKTX:"Índigo Coredo Black 8,0 oz"},
  {MATNR:"P21JF0020",MAKTX:"Ind Coating Shiny 7,5 oz"},
  {MATNR:"P21JF0021",MAKTX:"Indicolor Coating Metalic 7,3 oz"},
  {MATNR:"P21JF0022",MAKTX:"Índigo Design Duno 8,5 oz"},
  {MATNR:"P21JF0032",MAKTX:"Índigo Barni Focus Flex Blue 7,5 oz"},
  {MATNR:"P21JF0033",MAKTX:"Índigo Ilasi Black 9,0 oz"},
  {MATNR:"P21JF0037",MAKTX:"Índigo Mellini Blue/White 9,0 oz"},
  {MATNR:"P21JF0039",MAKTX:"Índigo Montello Black Blue 8,5 oz"},
  {MATNR:"P21JF0040",MAKTX:"Índigo Narni Dark Grey 7,4 oz"},
  {MATNR:"P21JF0042",MAKTX:"Índigo Arese Grey 9,5 oz"},
  {MATNR:"P21JF0046",MAKTX:"Índigo Camini Black 8,0 oz"},
  {MATNR:"P21JF0052",MAKTX:"Índigo New Lallio Albi Black 9,0 oz"},
  {MATNR:"P21JF0053",MAKTX:"Índigo New Lallio Special Deep Blue 9,0 oz"},
  {MATNR:"P21JF0054",MAKTX:"Índigo New Lallio Special Grey 9,0 oz"},
  {MATNR:"P21JF0055",MAKTX:"Índigo New Lallio Special 9,0 oz"},
  {MATNR:"P21JF0056",MAKTX:"Índigo Luce 160 6,5 oz"},
  {MATNR:"P21JF0057",MAKTX:"Índigo New Lallio Vinci Black 9,0 oz"},
  {MATNR:"P21JF0060",MAKTX:"Índigo Noale Checks Black Blue 8,6 oz"},
  {MATNR:"P21JF0061",MAKTX:"Índigo Onore Color 9,5 oz"},
  {MATNR:"P21JF0063",MAKTX:"Índigo Rizza Dark Blue 9,0 oz"},
  {MATNR:"P21JF0064",MAKTX:"Índigo Rizza Black 9,0 oz"},
  {MATNR:"P21JF0065",MAKTX:"Índigo Rizza Blue 9,0 oz"},
  {MATNR:"P21JF0067",MAKTX:"Índigo Rizza Smoky Grey 9,0 oz"},
  {MATNR:"P21JF0069",MAKTX:"Índigo Torri Black/White 9,0 oz"},
  {MATNR:"P21JF0070",MAKTX:"Índigo Torri Blue/White 9,0 oz"},
  {MATNR:"P21JF0078",MAKTX:"Índigo Urano Grey 8,8 oz"},
  {MATNR:"P21JF0087",MAKTX:"Indicolor Coating 6,7 oz"},
  {MATNR:"P21JF0089",MAKTX:"Indicolor Coating Shiny 7,2 oz"},
  {MATNR:"P21JF0091",MAKTX:"Indicolor Coating Snake Shiny 6,5 oz"},
  {MATNR:"P21JF0093",MAKTX:"Indicolor Coating Snake Ii 6,3 oz"},
  {MATNR:"P21JF0164",MAKTX:"Índigo Confort 10,5 oz"},
  {MATNR:"P21JF0169",MAKTX:"Índigo Coating Raw Leather 10 oz"},
  {MATNR:"P21JF0176",MAKTX:"Índigo Asti 7,7 oz"},
  {MATNR:"P21JF0177",MAKTX:"Índigo Chevron Blue 9,0 oz"},
  {MATNR:"P21JF0178",MAKTX:"Índigo Versatile Color 7,5 oz"},
  {MATNR:"P21JF0180",MAKTX:"Índigo Giove Blue 7,5 oz"},
  {MATNR:"P21JF0181",MAKTX:"Índigo Velvet Terni Blue 8,5 oz"},
  {MATNR:"P21JF0183",MAKTX:"Índigo Mare Checks Blue/Yellow 7,5 oz"},
  {MATNR:"P21JF0184",MAKTX:"Índigo Noale Checks Ii Blue 9,3 oz"},
  {MATNR:"P21JF0186",MAKTX:"Índigo Velvet Pallizzi Blue 7,9 oz"},
  {MATNR:"P21JF0190",MAKTX:"Índigo Jacquard Mosaic Blue 8,7 oz"},
  {MATNR:"P21JF0192",MAKTX:"Índigo Jacquard Romantic Blue 8,2 oz"},
  {MATNR:"P21JF0193",MAKTX:"Índigo Jacquard Leopard Blue 8,3 oz"},
  {MATNR:"P21JF0195",MAKTX:"Índigo Velvet Pied Coq Blue 7,9 oz"},
  {MATNR:"P21JF0196",MAKTX:"Índigo Jacquard Core Blue 8,7 oz"},
  {MATNR:"P21JF0197",MAKTX:"Índigo Jacquard Fantasy Blue 8,7 oz"},
  {MATNR:"P21JF0198",MAKTX:"Índigo Jacquard Blossom Blue 8,7 oz"},
  {MATNR:"P21JF0200",MAKTX:"Índigo Jacquard Pied Coq Blue 8,7 oz"},
  {MATNR:"P21JF0201",MAKTX:"Índigo Jacquard Radiant Blue 8,5 oz"},
  {MATNR:"P21JF0202",MAKTX:"Índigo Jacquard Navette Blue 10,4 oz"},
  {MATNR:"P21JF0203",MAKTX:"Índigo Printed Olbia Blue/Print 7,5 oz"},
  {MATNR:"P21JF0204",MAKTX:"Índigo Coating Snake Blue 7,5 oz"},
  {MATNR:"P21JF0208",MAKTX:"Índigo Cetim Slide Dark Blue 7,0 oz"},
  {MATNR:"P21JF0212",MAKTX:"Índigo Power Double Black Blue 7,2 oz"},
  {MATNR:"P21JF0213",MAKTX:"Índigo Guardia Dark Blue 8,5 oz"},
  {MATNR:"P21JF0215",MAKTX:"Índigo Mare Checks Blue/Wine 7,5 oz"},
  {MATNR:"P21JF0216",MAKTX:"Indigo Mare Checks Ii Blue/Wine 8,6 oz"},
  {MATNR:"P21JF0217",MAKTX:"Índigo Jacquard Star Blue 8,1 oz"},
  {MATNR:"P21JF0218",MAKTX:"Índigo Jacquard Dots Blue 9,3 oz"},
  {MATNR:"P21JF0219",MAKTX:"Índigo Jacquard Savage Blue 8,9 oz"},
  {MATNR:"P21JF0220",MAKTX:"Índigo Jacquard Starline Blue 8,1 oz"},
  {MATNR:"P21JF0221",MAKTX:"Índigo Jacquard Flowery Blue 8,1 oz"},
  {MATNR:"P21JF0222",MAKTX:"Índigo Jacquard Sublime Blue 8,1 oz"},
  {MATNR:"P21JF0224",MAKTX:"Índigo Confort Slim Deep Blue 7,7 oz"},
  {MATNR:"P21JF0225",MAKTX:"Índigo Cetim Power Extreme 7,5 oz"},
  {MATNR:"P21JF0226",MAKTX:"Indigo Cetim Power Trend Blue Black 8,4 oz"},
  {MATNR:"P21JF0227",MAKTX:"Indigo Cetim Power Trend Black 8,4 oz"},
  {MATNR:"P21JF0232",MAKTX:"Indigo Cetim Action Blue 10,0 oz"},
  {MATNR:"P21JF0235",MAKTX:"Índigo Mare Checks Narco Blue/Wine 8,7 oz"},
  {MATNR:"P21JF0236",MAKTX:"Índigo Mare Checks Badia Yellow/Wine 8,7 oz"},
  {MATNR:"P21JF0237",MAKTX:"Índigo Mare Stripe Fili Blue/Wine 8,7 oz"},
  {MATNR:"P21JF0238",MAKTX:"Índigo Mare Stripe Sesia Blue/Wine 8,7 oz"},
  {MATNR:"P21JF0240",MAKTX:"Índigo Moonshine Blue 10 oz"},
  {MATNR:"P21JF0242",MAKTX:"Indigo Power Arli Blue 4,5 oz"},
  {MATNR:"P21JF0245",MAKTX:"Indigo Cetim Power Lux Blue Black 9,7 oz"},
  {MATNR:"P21JX0002",MAKTX:"Índigo Premia Black Blue 5,6 oz"},
  {MATNR:"P21JX0005",MAKTX:"Índigo Premia Listras Black Blue 5,6 oz"},
  {MATNR:"P21JX0007",MAKTX:"Índigo Premia Listras Blue 5,6 oz"},
  {MATNR:"P21JX0008",MAKTX:"Índigo Dare Linen Checks Black 160 4,4 oz"},
  {MATNR:"P21JX0009",MAKTX:"Índigo Dare Linen Checks Blue 160 4,4 oz"},
  {MATNR:"P21JX0012",MAKTX:"Índigo Infine Blue 160 4,7 oz"},
  {MATNR:"P21JX0013",MAKTX:"Índigo Lioni Cross Blue Black 170 9,0 oz"},
  {MATNR:"P21JX0015",MAKTX:"Índigo Lucca Blue White 160 4,3 oz"},
  {MATNR:"P21JX0016",MAKTX:"Índigo Miane Black 160 4,5 oz"},
  {MATNR:"P21JX0017",MAKTX:"Índigo Miane Blue 160 4,5 oz"},
  {MATNR:"P21JX0018",MAKTX:"Índigo Miane Grey 160 4,5 oz"},
  {MATNR:"P21JX0025",MAKTX:"Índigo Savino Blue Black 170 8,5 oz"},
  {MATNR:"P21JX0026",MAKTX:"Índigo Navelly 170 6,8 oz"},
  {MATNR:"P21JX0027",MAKTX:"Índigo New Zeri Blue 170 6,0 oz"},
  {MATNR:"P21JX0029",MAKTX:"Índigo Serino Black 160  4,6 oz"},
  {MATNR:"P21JX0031",MAKTX:"Índigo Serino Blue 160 4,6 oz"},
  {MATNR:"P21JX0033",MAKTX:"Índigo Udine Black 170 10 oz"},
  {MATNR:"P21JX0034",MAKTX:"Índigo Udine Blue 170 10 oz"},
  {MATNR:"P21JX0035",MAKTX:"Índigo Uniti Blue 160 4,3 oz"},
  {MATNR:"P21JX0036",MAKTX:"Índigo Veroli Blue 170 10,8 oz"},
  {MATNR:"P21JX0038",MAKTX:"Índigo Kashmir 5,4 oz"},
  {MATNR:"P21JX0040",MAKTX:"Índigo Riace Blue 5,7 oz"},
  {MATNR:"P21JX0043",MAKTX:"Índigo Piquet Blue  5,3 oz"},
  {MATNR:"P21JX0047",MAKTX:"Índigo Linen New Blue 4,3 oz"},
  {MATNR:"P21JX0048",MAKTX:"Índigo New Rive Way Blue 4,5 oz"},
  {MATNR:"P21JX0049",MAKTX:"Indigo Lodi Tartan 3,8 oz"},
  {MATNR:"P21JX0050",MAKTX:"Indigo Forli Madras 4,2 oz"},
  {MATNR:"P21JX0052",MAKTX:"Indigo Liocel Amato Blue 5,3 oz"},
  {MATNR:"P21JX0053",MAKTX:"Indigo Liocel Felice Blue 4,7 oz"},
  {MATNR:"P21JX0054",MAKTX:"Indigo Liocel Molini Blue 4,8 oz"},
  {MATNR:"P21JX0055",MAKTX:"Indigo Paetê Exclusiv Blue 7,3 oz"},
  {MATNR:"P21JX0056",MAKTX:"Indigo Cadore Black Blue 10,0 oz"},
  {MATNR:"P21JX0058",MAKTX:"Índigo Pareto Blue 6 oz"},
  {MATNR:"P21JX0060",MAKTX:"Indigo Chambray Special Blue 2,5 oz"},
  {MATNR:"P21JX0061",MAKTX:"Índigo Ezio Blue 6 oz"},
  {MATNR:"P21JX0062",MAKTX:"Índigo Breno Blue 4,4 oz"},
  {MATNR:"P21JX0063",MAKTX:"Índigo Leno Blue 4,4 oz"},
  {MATNR:"P21JX0065",MAKTX:"Indigo Miane Basic Blue 3,7 oz"},
  {MATNR:"P21JX0067",MAKTX:"Indigo Linen Basic Blue 2,8 oz"},
  {MATNR:"P21JX0068",MAKTX:"Indigo Aquila Blue 5,4oz"},
  {MATNR:"P21JX0082",MAKTX:"Indigo Adro Blue River 4,3 oz"},
  {MATNR:"P21JX0083",MAKTX:"Indigo Edro Blue 4,3oz"},
  {MATNR:"P21JX0084",MAKTX:"Indigo Idro Blue 4,3oz"},
  {MATNR:"P21JF0246",MAKTX:"Indigo Pesaro Power Blue 7,1 oz"},
  {MATNR:"P21JF0247",MAKTX:"Indigo Pesaro Power Blue Black 7,1 oz"},
  {MATNR:"P21JX0085",MAKTX:"Indigo Ziano New Black 8,8 oz"},
  {MATNR:"P21JF0248",MAKTX:"Indigo Power Bienno Blue 9 oz"},
  {MATNR:"P21JF0258",MAKTX:"Indigo Cetim Power Trend New Dark Blue 8,5 Oz"},
  {MATNR:"P21JF0260",MAKTX:"Indigo Cetim Power Trend New Sky Blue 8,5 Oz"},
  {MATNR:"P21JF0261",MAKTX:"Indigo Power Bienno Blue 9,0 Oz"},
  {MATNR:"P21JF0248",MAKTX:"Indigo Braone New Cetim Blue 8,5 Oz"},
  {MATNR:"P21JF0065",MAKTX:"Indigo Rizza Blue 9,0 Oz"},
  {MATNR:"P21JX0093",MAKTX:"Indigo Savino New Blue Black 9,5 Oz"},
  {MATNR:"P21JX0087",MAKTX:"INDIGO PARMA BLUE 4,3oz"},
  {MATNR:"P21JF0266",MAKTX:"INDIGO PESARO BLACK 7,1 oz"},
  {MATNR:"P21JX0111",MAKTX:"INDIGO ARBUS"},
  {MATNR:"P21JX0112",MAKTX:"INDIGO DARIO"},
  {MATNR:"P21JF0276",MAKTX:"IND MAYA POWER"},
  {MATNR:"P21JF0274",MAKTX:"INDIGO BRAC POWER"},
  {MATNR:"P21JF0273",MAKTX:"INDIGO KAIAN"},
  {MATNR:"P21JF0277",MAKTX:"INDIGO SANTORINI 5,7oz"},
  {MATNR:"P21JX0115",MAKTX:"INDIGO TORTUGAS 4,3 oz"},
  {MATNR:"P21JX0114",MAKTX:"INDIGO SUCIA 3,7 oz"},
  {MATNR:"P21JX0108",MAKTX:"INDIGO DIGUE 3,6oz"},
  {MATNR:"P21JX0107",MAKTX:"INDIGO TRINIDAD 3,9oz"},
  {MATNR:"P21JF0278",MAKTX:"INDIGO LYME POWER"},
  {MATNR:"P21JF0279",MAKTX:"IND BYRON"},
  {MATNR:"P21JF0272",MAKTX:"IND LUCENA POWER"},
  {MATNR:"P21JF0270",MAKTX:"IND BESSA POWER"},
  {MATNR:"P21JF0271",MAKTX:"INDIGO EDEN"},
  {MATNR:"P21JF0264",MAKTX:"IND LACIO BLUE 6,2oz"},
  {MATNR:"P21JX0116",MAKTX:"INDIGO MALTA"},
  {MATNR:"P21JX0109",MAKTX:"INDIGO SANCHO"},
  {MATNR:"P21JX0113",MAKTX:"INDIGO LAGOS"},
  {MATNR:"P21JX0110",MAKTX:"INDIGO MARAU"},
  {MATNR:"P21JX0106",MAKTX:"INDIGO SARGI"},
  {MATNR:"P21JF0269",MAKTX:"IND SALINAS DOUBLE_1"},
  {MATNR:"P21JF0280",MAKTX:"IND CAIRU POWER"},
  {MATNR:"P21JF0275",MAKTX:"IND VITI POWER"},
  {MATNR:"P21JF0268",MAKTX:"IND SOLANO POWER"},
  {MATNR:"P21JX0104",MAKTX:"INDIGO CARMEL 3,6oz"},
  {MATNR:"P21JX0105",MAKTX:"INDIGO ZUMA 3,6oz"},
  {MATNR:"P21JX0103",MAKTX:"INDIGO MATINA 3,6oz"},
  {MATNR:"P21JX0102",MAKTX:"INDIGO CARMEM 3,6oz"},
  {MATNR:"P21JX0122",MAKTX:"INDIGO PETANI 4,0oz"},
  {MATNR:"P21JF0290",MAKTX:"INDIGO ASTÚRIAS 4,3oz"},
  {MATNR:"P21JX0126",MAKTX:"INDIGO MYRTHOS 4,0oz"},
  {MATNR:"P21JX0119",MAKTX:"INDIGO PAXOS 4,5oz"},
  {MATNR:"P21JX0127",MAKTX:"INDIGO MARTIM 4,5oz"},
  {MATNR:"P21JX0124",MAKTX:"INDIGO PERALTA 4,0oz"},
  {MATNR:"P21JX0117",MAKTX:"INDIGO DELOS 5oz"},
  {MATNR:"P21JX0121",MAKTX:"INDIGO OLAF 4,8oz"},
  {MATNR:"P21JF0284",MAKTX:"INDIGO CETIM POWER WENDY 9,5oz"},
  {MATNR:"P21JX0123",MAKTX:"INDIGO MAUAI 4,0oz"},
  {MATNR:"P21JX0125",MAKTX:"INDIGO KAUAI 4,0oz"},
  {MATNR:"P21JF0289",MAKTX:"INDIGO IBIZA 4,5oz"},
  {MATNR:"P21JF0283",MAKTX:"INDIGO CETIM CANNON POWER 9,0oz"},
  {MATNR:"P21JF0249",MAKTX:"Indicolor Cotton Cetim Power Eextreme 7,8 oz"},
  {MATNR:"P21JX0128",MAKTX:"INDIGO RUSTIC 4,4oz"},
  {MATNR:"P21JF0281",MAKTX:"INDICOLOR CETIM POWER EXTREME 145 7,5oz"},
  {MATNR:"P11JX0002",MAKTX:"Indileather Touch 10 oz"}
];
